export default __webpack_public_path__ + "static/media/category_f.9fc7e5c2.svg";